import React from "react";

import { Button } from "../../../../Shared/Buttons/Button";
import { dmnIdentity } from "../../../../../utils/dmnIdentity";
import { getEnvironmentProps } from "../../../../../utils/environment";
import dayjs from "dayjs";
import { useDiaryContext } from "../../../../../hooks/useDiaryContext";
import { ToggleButton } from "../../../../Shared/Buttons/ToggleButton";
import { document } from "@workspace/mobile";
import {
  errorHandler,
  apiFetchNotOkHandler
} from "../../../../../APIs/errorHandler";
/**
 * DownloadReservationLabelsContent Props
 */
type DownloadReservationLabelsContentProps = {
  onClose?: () => void;
  onBack?: () => void;
};

/**
 * DownloadReservationLabelsContent Modal
 *
 * @param param0
 * @returns
 */
export const DownloadReservationLabelsContent = ({
  onBack,
  onClose
}: DownloadReservationLabelsContentProps) => {
  const { venueConfig, date } = useDiaryContext();
  const [fileType, setFileType] = React.useState<string>("pdf");

  const handleBack = () => {
    onBack?.();
  };

  const handleDownload = async () => {
    const token = await dmnIdentity.getAccessToken();
    const environmentVars = getEnvironmentProps(token);
    const isPDF = fileType === "pdf";

    const url = new URL(
      `${environmentVars?.COLLINS_API_BASE_URL}/run-sheets/reservation-labels/${
        venueConfig?._id ?? ""
      }/${dayjs(date).format("YYYY-MM-DD")}`
    );
    url.searchParams.set("output", fileType);
    url.searchParams.set("source", "admin");

    try {
      const request = await fetch(url, {
        headers: {
          "content-type": "application/json",
          authorization: `Bearer ${token}`
        },
        method: "GET"
      });

      if (!request.ok) {
        apiFetchNotOkHandler(request, "Error downloading reservation labels");
        return;
      }

      const arrBuffer = await request.arrayBuffer();
      const file = new Blob([arrBuffer], {
        type: isPDF ? "application/pdf" : "application/msword"
      });
      const fileReader = new FileReader();

      fileReader.onloadend = async () => {
        const result = fileReader.result as string;
        const [, mimeType, , data] = result.split(/[:;,]+/);
        const fileName = `guest-list.${isPDF ? "pdf" : "doc"}`;

        document.open({ mimeType, data, fileName });
      };

      fileReader.readAsDataURL(file);
    } catch (error) {
      errorHandler(error, "Error downloading reservation labels");

      return;
    }

    onClose?.();
  };

  return (
    <div className="DownloadFileCotainer flex flex-col flex-1">
      <div className="DownloadFileContent flex-1 flex flex-col">
        <p>Generate/view reservation cards for customers. </p>
        <p>
          <strong>File type</strong>
        </p>
        <div>
          <div className="InlineTabsWrapper InlineTabsWrapperStart">
            <ToggleButton
              text1="PDF"
              text2="Word/Doc"
              selected={fileType === "pdf"}
              onClick={() => {
                setFileType(fileType === "pdf" ? "doc" : "pdf");
              }}
            />
          </div>
        </div>
      </div>
      <div className="DownloadFileFooter flex-none flex flex-row gap-2.5">
        <Button className="DownloadFileFooterButton" onClick={handleBack}>
          Back
        </Button>
        <Button
          className="DownloadFileFooterButton"
          onClick={handleDownload}
          type="primary"
        >
          Download Reservation Labels
        </Button>
      </div>
    </div>
  );
};
